import { render, staticRenderFns } from "./Dashboard.vue.html?vue&type=template&id=b401642e&external"
import script from "./Dashboard.vue.js?vue&type=script&lang=js&external"
export * from "./Dashboard.vue.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports